var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarginTopMd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 98,
    viewBox: "0 0 196 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_60_94)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 98,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 47,
    width: 180,
    height: 60,
    rx: 5,
    fill: "#007FFF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 47,
    width: 180,
    height: 60,
    rx: 5,
    stroke: "#007FFF",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3536 18.6464C98.1583 18.4512 97.8417 18.4512 97.6464 18.6464L94.4645 21.8284C94.2692 22.0237 94.2692 22.3403 94.4645 22.5355C94.6597 22.7308 94.9763 22.7308 95.1716 22.5355L98 19.7071L100.828 22.5355C101.024 22.7308 101.34 22.7308 101.536 22.5355C101.731 22.3403 101.731 22.0237 101.536 21.8284L98.3536 18.6464ZM97.6464 39.3536C97.8417 39.5488 98.1583 39.5488 98.3536 39.3536L101.536 36.1716C101.731 35.9763 101.731 35.6597 101.536 35.4645C101.34 35.2692 101.024 35.2692 100.828 35.4645L98 38.2929L95.1716 35.4645C94.9763 35.2692 94.6597 35.2692 94.4645 35.4645C94.2692 35.6597 94.2692 35.9763 94.4645 36.1716L97.6464 39.3536ZM97.5 19L97.5 39L98.5 39L98.5 19L97.5 19Z",
    fill: "#007FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: -46,
    width: 180,
    height: 58,
    rx: 5,
    fill: "#64748B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: -46,
    width: 180,
    height: 58,
    rx: 5,
    stroke: "#64748B",
    strokeDasharray: "4 4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60_94"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 98,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarginTopMd);
export default __webpack_public_path__ + "static/media/margin_top_md.8a95d6c692f12fd6e24fea3bef91a9b1.svg";
export { ForwardRef as ReactComponent };